import React from 'react';
import qs from 'query-string';
import pick from 'lodash/pick';
import Page from 'pages/Page';
import SearchForm from "containers/SearchForm.container";
import Map from 'components/common/Map';
import ListingList from 'components/ListingList';
import Spinner from 'components/common/Spinner';
import { pluralize } from 'utils';

export default class Listings extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      markers: props.markers
    };

    this.onEnterListing = this.onEnterListing.bind(this);
    this.onReachBottom = this.onReachBottom.bind(this);
  }

  onEnterListing(listing) {
    const markers = this.state.markers.map(marker => ({
      ...marker,
      active: marker.listing._id === listing._id
    }));

    this.setState({ markers });
  }

  onReachBottom() {
    const { resultCount, listingCount, isFetching } = this.props;
    if (!isFetching && resultCount > listingCount) {
      this.props.fetchListings({ ...this.props.query, skip: this.props.skip + 25, isSearch: true, isShowMore: true });
    }
  }

  render() {
    const { pageTitle, resultCount, listings, query, isFetching, isFetchingMore } = this.props;
    const { markers } = this.state;

    let content;
    if (isFetching) {
      content = <div className="d-flex justify-content-center align-items-center h-100" style={{minHeight:200}}><Spinner/></div>
    } else if (resultCount) {
      content = <ListingList listings={listings} onEnterListing={this.onEnterListing} onReachBottom={this.onReachBottom} query={qs.stringify(pick(query, ['startDate', 'endDate']))} isFetching={isFetchingMore}/>
    } else {
      content = <div className="py-5 pl-5"><h4>No results</h4><div className="font-size-md">Try adjusting your search</div></div>
    }

    return (
    <Page title={pageTitle}>
      <div className="listings-page">
        <div className="py-45 py-md-4 px-5 px-md-0 bg-faded-1 justify-content-center d-flex">
          <div className="container px-0">
            <SearchForm />
          </div>
        </div>
        <div className="separator pt-3 pb-3 pl-xl-5 pl-lg-4 pl-5 font-size-lg">
          {resultCount} {pluralize('result', resultCount)}
        </div>
        <div className="row no-gutters listings-row separator">
          <div className="col-md-7 no-gutters">
            {content}
          </div>
          <div className="col-md-5 hidden-sm-down">
            <Map markers={markers}/>
          </div>
        </div>
      </div>
    </Page>);
  }
}


// WEBPACK FOOTER //
// ./src/pages/Listings.js